// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.E2koSa7ERmjDWqHw6GHG {
  position: relative;
}
.E2koSa7ERmjDWqHw6GHG > svg {
  transform: rotate(-90deg);
  display: block;
  fill: var(--dry-bg);
}
.E2koSa7ERmjDWqHw6GHG > svg > circle:first-child {
  stroke: var(--dry-primary);
}
.E2koSa7ERmjDWqHw6GHG > svg > circle:last-child {
  stroke: var(--dry-bg);
  stroke-dasharray: 126;
  transition: all 0.6s;
}
.CEscnWxVZsE8RYj_HDZw {
  position: absolute;
  inset: 25%;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `E2koSa7ERmjDWqHw6GHG`,
	"content": `CEscnWxVZsE8RYj_HDZw`
};
export default ___CSS_LOADER_EXPORT___;
